#import "../../../engagement/graphql/fragments/sms-edition-engagement-stats-fragment.graphql"

fragment SmsBroadcastEngagementStatsFragment on SmsCampaign {
    id
    edition {
        id
        engagementStats {
            ...SmsEditionEngagementStatsFragment
        }
    }
}
